import { GridColumn } from 'types/grid';
import { sideBarMenuList } from './sidebarUtils';
import { ManageGridData } from 'types/manage';
import { SidebarSubMenu } from 'types/sidebar';

export const manageTabs =
  (sideBarMenuList.find((menu) => (menu as SidebarSubMenu).subMenuTitle === 'Admin') as SidebarSubMenu)?.children ?? [];

